export interface FeaturePermissions {
  view: boolean
  create: boolean
  edit: boolean
  delete: boolean
}
export interface MemberPermissions {
  intakes: FeaturePermissions
  audits: FeaturePermissions
}
export type MemberFeature = keyof MemberPermissions
export const fullMemberPermissions = (): MemberPermissions => ({
  intakes: { view: true, create: true, edit: true, delete: true },
  audits: { view: true, create: true, edit: true, delete: true },
})
export function normalizeMemberPermissions(
  value?: Partial<MemberPermissions>,
): MemberPermissions {
  const result = fullMemberPermissions()
  for (const feature of ['intakes', 'audits'] as const) {
    result[feature] = { ...result[feature], ...value?.[feature] }
    if (!result[feature].view)
      result[feature] = {
        view: false,
        create: false,
        edit: false,
        delete: false,
      }
  }
  return result
}
export function hasLimitedAccess(value?: MemberPermissions): boolean {
  return Object.values(normalizeMemberPermissions(value)).some((feature) =>
    Object.values(feature).some((allowed) => !allowed),
  )
}
export function canChangeRecord(
  permission: FeaturePermissions,
  userId: string | undefined,
  record?: { createdBy?: string; status?: string; completedAt?: string },
): boolean {
  return (
    permission.view &&
    (permission.edit ||
      !!(
        permission.create &&
        userId &&
        record?.createdBy === userId &&
        !record.completedAt &&
        record.status !== 'complete'
      ))
  )
}
